import PersistentData from "@/classes/PersistentData";


const pd = new PersistentData('shopping-list');

export function getProductSku(product) {
    let sku = String(product?.sku || product?.productId || '').split('|');
    return (sku[1] ?? sku[0])?.toLowerCase();// product?.sku || product?.productId;//.split(':').pop();
}


export default class ShoppingListController {
    constructor(flyerId) {
        this.id = flyerId;
    }

    /**
     *
     * @param id - Unique Product identifier ie. sku
     * @param {object} product
     * @returns {any}
     */
    addItem(id, product) {
        const key = `${this.id}/${id}`;
        let listItem = pd.getData(key);
        if(!listItem){
            listItem = {
                qty: 0
            }
        }
        listItem.qty++;
        listItem.product = product;
        pd.setData(key, listItem);
        return listItem;
    }

    removeItem(id) {
        const key = `${this.id}/${id}`;
        let listItem = pd.getData(key);
        if(listItem && listItem.qty > 1) {
            listItem.qty--;
            pd.setData(key, listItem);
        } else {
            pd.removeData(key);
        }
        return listItem;
    }

    clear() {
        // Scope the clear to this list's own id (now the storeId) so it doesn't wipe
        // every other store's saved list too.
        pd.removeAll(this.id);
    }

    getList() {
        return pd.getAll(this.id);
    }




}
